import { useContext } from 'react';
import { useAtom, deref } from '@dbeining/react-atom';
import { StateContext } from '../state/stateContext';
const useGlobalAtom = typeof window !== 'undefined' ? useAtom : useDirectAtom;
function useDirectAtom(atom, opts) {
    const state = deref(atom);
    const select = opts && opts.select;
    return typeof select === 'function' ? select(state) : state;
}
/**
 * Hook to obtain the global state context, which gives you directly
 * all actions, state, and more of the Piral instance.
 * If you are only interested in reading out the state, use the
 * `useGlobalState` hook instead.
 */
export function useGlobalStateContext() {
    return useContext(StateContext);
}
export function useGlobalState(select) {
    const { state } = useGlobalStateContext();
    return useGlobalAtom(state, select && { select });
}
//# sourceMappingURL=globalState.js.map